// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"9064d5ba","37":"d7c58078","49":"6dc3d08a","74":"1ca55d82","277":"73b33e3c","435":"7e50227d","707":"c7142cf2","766":"c77dbe6f","839":"e42cc589","872":"0693f1f3","931":"31fe9e2c"}[chunkId] + ".chunk.js";
};